// extracted by mini-css-extract-plugin
export default {"nameInputBox":"NameInput_nameInputBox__RdQ5G"};